export default "__VITE_ASSET__Dpl803rO__"